import { apiService } from "api/apiService";
import { schoolFromDto } from "shared/mappers/school.mapper";
import { schoolSettingsFromDto } from "shared/mappers/schoolSettings.mapper";
import type { School } from "shared/types/school.types";
import type { SchoolSettings } from "shared/types/schoolSettings.types";

export const fetchSchool = async (schoolId: number): Promise<School> => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data } = await apiService.get<{ data: any }>(
    `api/schools/${schoolId}`,
  );

  return schoolFromDto(data.data);
};

export const fetchSchoolSettings = async (
  schoolId: number,
): Promise<SchoolSettings> => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data } = await apiService.get<any>(`api/school/${schoolId}/settings`);

  return schoolSettingsFromDto(data);
};
